<template src="./pagination.html"></template>

<script lang="ts">
import { nextTick } from 'vue'
import msg from 'services/msg'

export default {
  props: {
    ariaLabelledBy: String,
    contentType: {
      type: String,
      required: true
    },
    currentPage: {
      type: Number,
      default: 1
    },
    total: {
      type: Number,
      default: 0
    },
    isButtonStyle: Boolean,
    initialPageSize: { // Set if the 1st page is to have a different pageSize than the others
      type: Number,
      default: 0
    },
    pageSize: {
      type: Number,
      default: 10
    },
    hidePageList: {
      type: Boolean,
      default: false
    },
    title: { // for accessibility aria-label
      type: String,
      // had to import msg as this.$msg does not work here
      default: () => msg('pagination.title')
    }
  },
  emits: ['updatePage'],
  // directives: { focus: { inserted: el => el.focus() } },
  computed: {
    buttonType() {
      return this.isButtonStyle ? 'primary' : 'icon'
    },
    numberOfPages() {
      if (this.pageSize === 0 || this.total === 0) {
        return 0
      }
      if (this.total <= this.initialPageSize) {
        return 1
      }
      const totalLessInitialPageSize = this.total - this.initialPageSize
      return Math.ceil(totalLessInitialPageSize / this.pageSize) + (this.initialPageSize ? 1 : 0)
    },
    hasMore() {
      return this.currentPage < this.numberOfPages
    },
    hasPrevious() {
      return this.currentPage > 1
    },
    pageList() {
      const delta = 1
      const range = []
      const rangeData = []
      let l

      // first gather all the page numbers that will be shown
      range.push(1)
      const insideStartPage = Math.min(this.currentPage - delta, this.numberOfPages - 4)
      const insideEndPage = Math.max(5, this.currentPage + delta)
      for (let i = insideStartPage; i <= insideEndPage; i++) {
        if (i < this.numberOfPages && i > 1) {
          range.push(i)
        }
      }
      range.push(this.numberOfPages)

      // now add each to the rangeData, adding any needed filled in page (for 2 page gaps) and
      // ellipsis spot if needed as well
      range.forEach((v) => {
        if (l) {
          if (v - l === 2) {
            rangeData.push(this.getDataForPage(l + 1))
          } else if (v - l !== 1) {
            rangeData.push(this.getDataForPage((l + 1), true))
          }
        }
        rangeData.push(this.getDataForPage(v))
        l = v
      })
      return rangeData
    }
  },
  methods: {
    getDataForPage(page, isEllipsis = false) {
      const isCurrentPage = page === this.currentPage
      const msgKey = isCurrentPage ? 'pagination.currentPage' : 'pagination.goToPage'
      return { page, isCurrentPage, label: this.$msg(msgKey, [page]), isEllipsis }
    },
    next() {
      this.$emit('updatePage', this.currentPage + 1)
    },
    back() {
      this.$emit('updatePage', this.currentPage - 1)
    },
    focusOnCurrentPage() {
      nextTick(() => {
        this.$el.querySelector('.tt-o-page-list__number.tt-is-active a').focus()
      })
    },
    goToPage(pageNum) {
      this.$emit('updatePage', pageNum)
      this.focusOnCurrentPage()
    }
  }
}
</script>

<style lang="scss" src="./pagination.scss"></style>
